import { render, staticRenderFns } from "./StatisticsCornersGoalsMobile.vue?vue&type=template&id=543394b8&scoped=true&"
import script from "./StatisticsCornersGoalsMobile.vue?vue&type=script&lang=js&"
export * from "./StatisticsCornersGoalsMobile.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCornersGoalsMobile.vue?vue&type=style&index=0&id=543394b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543394b8",
  null
  
)

export default component.exports